const FooterDataList = [
  { id: 1, text: "About." },
  { id: 2, text: "Testimonials." },
  { id: 3, text: "Pricing." },
  { id: 4, text: "Contacts." },
];
export default FooterDataList;
